// loadComponent comunica con la libreria npm che abbiamo installato, qui stiamo importando McElement che in sostanza estende HTMLElement (lo trovi nella sezione test)
// tutti i componenti che ti servono vanno chiamati così, con /components/nome-componente.js se sono su npm, li trovi tutti nella tab Componenti in sezione test
await loadComponent('./components/mc-element.js', false);

// queste sono le uniche librerie che hanno "res" invece che "components", le ho messe qua solo per farti vedere come si importano
await loadComponent('./res/mc-utils.js', false); // la trovi documentata sulla tab McUtils nella sezione test
await loadComponent('./res/mc-events.js', false); // la trovi documentata sulla tab Eventi nella sezione test
await loadComponent('./res/mc-shopify.js', false); // la trovi documentata sulla tab McShopify nella sezione test

class MainCollection extends McElement {

  connectedCallback() {
  }
}

if (!customElements.get('main-collection')) {
  customElements.define('main-collection', MainCollection);
}

window.MainCollection = MainCollection;